import { getPersonalInfoLogin } from "../../services/personService"

export const setUserInfo = () => {
    return async dispatch => {
            const { data } = await getPersonalInfoLogin()
            await dispatch({ type: 'SET_USER', payload: data.data })
        }
        // return { type: 'SET_USER', payload: res }
}